export class TimeHelper {
    static timeStringToSec = timestring => {
        if (timestring == null) return 0;

        var parts = timestring.split(":");

        return (
            Number.parseFloat(parts[0]) * 3600 +
            Number.parseFloat(parts[1]) * 60 +
            Number.parseFloat(parts[2])
        );
    };
    static formatSecondsAsTime = seconds => {
        return [
            TimeHelper.pad(Math.floor(seconds / 3600) % 60),
            TimeHelper.pad(Math.floor(seconds / 60) % 60),
            TimeHelper.pad(Math.floor(seconds) % 60)
        ].join(":");
    };
    static pad = num => {
        if (num < 10) {
            return "0" + num;
        } else {
            return "" + num;
        }
    };
}

export default function articlesCalc() {
    const columns = [
        "article_number",
        "article_group_id",
        "global_settings",
        "originalArticle",
        "infoboard_id",
        "objectsPerRow",
        "customer",
        "name",
        "quantity",
        "unit",
        "width",
        "height",
        "_width_circumference",
        "_height_circumference",
        "print_direction",
        "_print_direction",
        "weight",
        "_weightWithThreeDecimals",
        "start_time",
        "production_time",
        "time",
        "_time",
        "extra_cost",
        "start_cost",
        "production_cost",
        "_cost",
        "purchase_price",
        "_purchase_price",
        "start_price",
        "stop_price",
        "start_price_volume",
        "stop_price_volume",
        "_production_cost",
        "_margin",
        "_price",
        "_discount",
        "_price_after_discount",
        "mode",
        "price_model"
    ];
    this.data = {};

    this.get = name => {
        const { data } = this;
        let value = 0.0;

        switch (name) {
            case "extra_cost":
                value =
                    Number.parseFloat(data.extra_cost) *
                    Number.parseFloat(data.quantity);
                break;

            case "width_circumference":
                if (data.width == 0 || data.height == 0) {
                    return "-";
                } else {
                    return data.width * 2 + data.height * 2;
                }

            case "height_circumference": // TODO: Vad är denna kolumn?
                if (data.width == 0 || data.height == 0) {
                    return "-";
                } else {
                    return "-";
                }

            case "print_direction":
                if (data.print_direction == 0) return "";
                return data.print_direction == 0 ? "Stående" : "Liggande";

            case "weight":
                let weight = this.getWeight();
                return weight > 0 ? weight : "";

            case "weightWithThreeDecimals":
                let roundedWeight = this.getWeight();
                return roundedWeight > 0 ? roundedWeight.toFixed(3) : "";

            case "production_time":
                const totalSeconds = this.getProductionSeconds();
                return TimeHelper.formatSecondsAsTime(totalSeconds);

            case "time":
                let startSeconds = this.getStartSeconds();
                let productionSeconds = this.getProductionSeconds();
                return TimeHelper.formatSecondsAsTime(
                    startSeconds + productionSeconds
                );

            case "production_cost":
                return this.getProductionCost().toFixed(2);

            case "purchase_price":
                return this.getPurchasePrice().toFixed(2);

            case "price":
                return this.getPrice().toFixed(2);

            case "margin":
                return this.getMargin().toFixed(2) + "%";

            case "discount":
                return this.getDiscount().toFixed(2) + "%";

            case "price_after_discount":
                return this.getPriceAfterDiscount().toFixed(2);

            default:
                break;
        }

        if (Number.isNaN(value)) {
            value = 0.0;
        }
        return value.toFixed(2);
    };
    this.getColumns = () => columns;
    this.setData = data => {
        const newData = {};
        columns
            .filter(column => column[0] !== "_")
            .forEach(column => {

                if ("undefined" !== data[column])
                    newData[column] = data[column];
            });

        this.data = newData;
    };
    this.getStartSeconds = () => {
        const { start_time } = this.data;
        return TimeHelper.timeStringToSec(start_time);
    };
    this.getProductionSeconds = () => {
        const { production_time, quantity } = this.data;
        if (isNaN(quantity) || quantity == 0) return 0;

        const seconds = TimeHelper.timeStringToSec(production_time);
        const totalSeconds =
            Number.parseFloat(seconds) * Number.parseFloat(quantity);
        return totalSeconds;
    };
    this.getDiscount = () => {
        let base;
        if (typeof window.costEstimate != "undefined") {
            base = window.costEstimate;
        } else if (typeof window.tenderSettings != "undefined") {
            base = window.tenderSettings;
        } else if (typeof window.standardTenderSettings != "undefined") {
            base = window.standardTenderSettings;
        } else if (typeof window.orderConfirmationSettings != "undefined") {
            base = window.orderConfirmationSettings;
        } else if (typeof window.deliverySettings != "undefined") {
            base = window.deliverySettings;
        }

        if (base.data.customer == null) return 0;

        const discounts = base.data.globalSettings.discounts;
        const customer = base.data.customer;

        if (typeof discounts == "undefined") return 0;
        if (typeof customer == "undefined") return 0;

        if (typeof discounts[this.data.article_group_id] == "undefined")
            return 0;
        if (
            typeof discounts[this.data.article_group_id][
            customer.customer_group_id
            ] == "undefined"
        )
            return 0;

        return Number.parseFloat(
            discounts[this.data.article_group_id][customer.customer_group_id]
        );
    };
    this.getDiscountSek = (quantityMultiplier = 1) => {
        if (this.getDiscount() == 0) return 0;

        let discountMultiplier = this.getDiscount() / 100;
        return this.getPrice(quantityMultiplier) * discountMultiplier;
    };
    this.getPriceAfterDiscount = (quantityMultiplier = 1) => {
        let discountPercent = 100 - this.getDiscount();
        let discountMultiplier = discountPercent / 100;
        return this.getPrice(quantityMultiplier) * discountMultiplier;
    };
    this.getMargin = (quantityMultiplier = 1) => {
        let quantity = Number.parseFloat(this.data.quantity);
        if (isNaN(quantity) || quantity == 0) return 0;
        const marginSek = this.getMarginSek(quantityMultiplier);

        if (marginSek == 0) return 0;

        return (
            (this.getMarginSek(quantityMultiplier) /
                this.getPriceAfterDiscount(quantityMultiplier)) *
            100
        );
    };
    this.getTotalCost = (quantityMultiplier = 1) => {
        return (
            this.getProductionCost(quantityMultiplier) +
            this.getPurchasePrice(quantityMultiplier)
        );
    };
    this.getMarginSek = (quantityMultiplier = 1) => {
        return (
            this.getPriceAfterDiscount(quantityMultiplier) -
            this.getTotalCost(quantityMultiplier)
        );
    };
    this.getPrice = (quantityMultiplier = 1) => {

        let priceModel = 'DEFAULT';
        
        if (this.data.price_model) {
            priceModel = this.data.price_model;
        } else if (this.data.originalArticle) {
            priceModel = this.data.originalArticle.price_model;
        }

        let quantity = Number.parseFloat(this.data.quantity);

        if (isNaN(quantity) || quantity == 0) return 0;

        if (this.data.infoboard_id == 2 || (this.data.infoboard_id == 5 && this.data.mode && this.data.mode == 'size')) {

            var sheetSizeM2 = (this.data.width * this.data.height) / 1000000;
            var maxObjectsPerSheet = this.data.objectsPerRow;
            var sheetsNeeded = quantityMultiplier / maxObjectsPerSheet;

            if (this.data.infoboard_id == 5) {
                sheetsNeeded = Math.ceil(sheetsNeeded);
            }

            let totalSheetSizeAreaNeeded = sheetsNeeded * sheetSizeM2;

            return (
                Number.parseFloat(this.data.start_cost) +
                this.data.extra_cost * quantity +
                getUnitPrice(
                    Number.parseFloat(totalSheetSizeAreaNeeded),
                    this.data.start_price,
                    this.data.stop_price,
                    this.data.start_price_volume,
                    this.data.stop_price_volume,
                    priceModel
                )
            );
        } else if (this.data.infoboard_id == 6) {
            quantity *= quantityMultiplier;

            if (typeof this.data.originalArticle != 'undefined') {
                // Calculate new start and stop price based on dynamically set purchase price
                this.data.start_price = this.data.purchase_price * (1 + (this.data.originalArticle.surcharge_start_percent/100));
                this.data.stop_price = this.data.purchase_price * (1 + (this.data.originalArticle.surcharge_stop_percent/100));
            }

            return (
                Number.parseFloat(this.data.start_cost) +
                this.data.extra_cost * quantity +
                getUnitPrice(
                    Number.parseFloat(quantity),
                    this.data.start_price,
                    this.data.stop_price,
                    this.data.start_price_volume,
                    this.data.stop_price_volume,
                    priceModel
                )
            );
        } else {
            quantity *= quantityMultiplier;

            return (
                Number.parseFloat(this.data.start_cost) +
                this.data.extra_cost * quantity +
                getUnitPrice(
                    Number.parseFloat(quantity),
                    this.data.start_price,
                    this.data.stop_price,
                    this.data.start_price_volume,
                    this.data.stop_price_volume,
                    priceModel
                ) 
            );
        }
    };
    this.getPurchasePrice = (quantityMultiplier = 1) => {
        let quantity = Number.parseFloat(this.data.quantity);

        if (isNaN(quantity) || quantity == 0) return 0;

        if (this.data.infoboard_id == 2 || (this.data.infoboard_id == 5 && this.data.mode && this.data.mode == 'size')) {
            var sheetSizeM2 = (this.data.width * this.data.height) / 1000000;
            var maxObjectsPerSheet = this.data.objectsPerRow;
            var sheetsNeeded = quantityMultiplier / maxObjectsPerSheet;

            if (this.data.infoboard_id == 5) {
                sheetsNeeded = Math.ceil(sheetsNeeded);
            }

            let totalSheetSizeAreaNeeded = sheetsNeeded * sheetSizeM2;

            return (
                Number.parseFloat(this.data.purchase_price) *
                totalSheetSizeAreaNeeded
            );
        } else {
            return (
                Number.parseFloat(this.data.purchase_price) *
                quantity *
                quantityMultiplier
            );
        }
    };

    this.getProductionCost = (quantityMultiplier = 1) => {
        let quantity = Number.parseFloat(this.data.quantity);
        if (isNaN(quantity) || quantity == 0) return 0;

        return (
            Number.parseFloat(this.data.production_cost) *
            quantity *
            quantityMultiplier
        );
    };

    this.getWeight = () => {
        if (this.data.infoboard_id == 6) {
            return Number.parseFloat(this.data.weight) * Number.parseFloat(this.data.quantity);
        } else {
            return (Number.parseFloat(this.data.weight) / 1000) * Number.parseFloat(this.data.quantity);
        }
        
    }
}
